import { FormatPathArgs } from '@farewill/ui/components/Image/types'
import { COLOR, FONT } from '@farewill/ui/tokens'
import { MarkObj } from 'rc-slider/lib/Marks'

export type SliderConfig = MarkObj & {
  value: number
  text: string
  image: string
  formatImagePath?: ({ path, ext, width }: FormatPathArgs) => string
}

export const SLIDER_MARK_STYLES: MarkObj['style'] = {
  top: '-45px',
  fontSize: '16px',
  color: COLOR.BLACK,
  fontWeight: FONT.WEIGHT.MEDIUM,
}
